<template>
  <div class="profiles-wrapper" :class="{'fetching': fetching}" v-if="entries && entries.length">
    <transition name="fade" mode="out-in">
      <div class="spinner-wrapper" v-if="fetching">
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>
    </transition>
    <el-table
      :data="entries"
      stripe
      style="width: 100%"
      class="leaderboard-table"
      :default-sort="{order: 'descending', prop: 'calculatedScore'}"
    ><el-table-column
        type="index"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="calculatedProfileObject.fields.name"
        label="Avatar"
      >
        <template slot-scope="scope">
          <div class="icon-wrapper">
            <div
              class="avatar"
              :style="{backgroundImage: `url(${getAvatar(scope)})`}"
            ></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="responses[0].selected[0]"
        label="Usuario"
      >
        <template slot-scope="scope">
          {{getNickname(scope)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="calculatedProfileObject.fields.name"
        label="Perfil"
      ></el-table-column>
      <el-table-column
        prop="calculatedResponseTime"
        label="Tiempo"
        sortable
      ></el-table-column>
      <el-table-column
        prop="calculatedScore"
        label="Puntaje"
        sortable
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  name: 'Leaderboard',

  props: ['entries', 'fetching'],

  computed: {
    profiles () {
      return this.$store.state.testResults.profiles
    }
  },

  methods: {
    getAvatar (scope) {
      if (scope.row.calculatedProfileObject) {
        return scope.row.calculatedProfileObject.fields.avatar.fields.file.url
      } else {
        return this.profiles[0].fields.avatar.fields.file.url
      }
    },
    getNickname (scope) {
      if (scope.row.responses[0]) {
        if (scope.row.responses[0].selected[0] === 'next') {
          if (scope.row.surveyData.browserReport && scope.row.surveyData.browserReport.os) {
            var browserReport = scope.row.surveyData.browserReport
            return browserReport.os.name + '/' + browserReport.os.version + ' ' + browserReport.screen.width + 'x' + browserReport.screen.height
          }
          return `Usuario ${Math.floor(Math.random() * 10000)}`
        } else {
          return scope.row.responses[0].selected[0]
        }
      } else {
        return ''
      }
    },
    getProfile (profileId) {
      var matchingProfile = this.profiles.filter(profile => {
        return profile.sys.id.toString() === profileId.toString()
      })
      return matchingProfile[0]
    },
    calculateProfiles () {
      if (!this.profiles.length || !this.entries.length) {
        return {}
      }
      // Add the calculated profile to each entry
      this.entries.forEach(entry => {
        entry.calculatedProfile = this.calculateProfile(entry.surveyData.weightedTestResults)
        entry.calculatedProfileObject = this.getProfile([entry.calculatedProfile])
      })

      // Add the score per user to a high-level prop
      this.entries.forEach(entry => {
        var wtr = entry.surveyData.weightedTestResults
        if (wtr && wtr.length) {
          entry.calculatedScore = ((wtr[0] + wtr[1] + wtr[2] + wtr[3]) / 4 ) * 4
        }
      })

      this.canRender = true
    },
    calculateProfile (weightedTestResults) {
      if (!weightedTestResults || !this.profiles.length || !this.entries.length) {
        return null
      }
      const tr = weightedTestResults

      var outputProfile = ''
      this.$store.state.testResults.profiles.forEach((profile, i) => {
        var match = 0
        var minVector = profile.fields.weightedMin.split(',')
        var maxVector = profile.fields.weightedMax.split(',')
        minVector.forEach((variable, j) => {
          if (tr[j] >= minVector[j] && tr[j] <= maxVector[j]) match++
        })

        if (match === minVector.length) {
          outputProfile = Object.assign({}, profile)
        }
      })

      return outputProfile.sys.id
    }
  },

  mounted () {
    this.calculateProfiles()
  },

  filters: {
    filterNaN (value) {
      if (isNaN(value)) {
        return 0
      }
      return value
    }
  },

  watch: {
    'entries': function (newVal) {
      if (newVal.length) {
        this.calculateProfiles()
      }
    }
  }

}
</script>

<style scoped lang="scss">
.spinner-wrapper {
  transform: scale(2);
  width: 100%;
  height: 100%;
}

.profiles-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  min-height: calc(100vh - 4em);
  &.fetching {
    opacity: 0.05;
  }
}
.profile-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 90vw;
  margin: 2em 0;

  @include breakpoint($tablet) {
    min-width: 12em;
    margin: 0.2em 0;
  }

  @include breakpoint($desktop) {
    min-width: 6em;
    margin: 0.2em 0;
  }

  @include breakpoint($fullhd) {
    min-width: 8em;
  }

  .profile-name {
    font-size: 1.3em;
    margin-top: 0.5em;
    margin-bottom: 0em;
    @include breakpoint($tablet) {
      font-size: 0.7em;
    }
    @include breakpoint($desktop) {
      font-size: 0.6em;
    }
  }
  .percentage {
    font-size: 1.3em;
    @include breakpoint($tablet) {
      font-size: 1em;
      margin-bottom: 0.4em;
    }
  }
}

.profile-overlay {
  position: fixed;
}
.leaderboard-table {
  @include breakpoint($tablet) {
    font-size: 0.6em;
  }
  @include breakpoint($desktop) {
    font-size: 0.5em;
  }
}
</style>
<style lang="scss">
.el-table__row {
  .icon-wrapper {
    width: 70px;
    height: 0;
    padding-bottom: 70px;
    background: $gray-light;
    border-radius: 10em;
    @include breakpoint($tablet) {
      width: 8em;
      padding-bottom: 8em;
    }
    @include breakpoint($desktop) {
      width: 3.5em;
      padding-bottom: 3.5em;
    }

    @include breakpoint($fullhd) {
      width: 6em;
      padding-bottom: 6em;
    }
    .avatar {
      width: 100%;
      height: 0;
      padding-bottom: 75%;
      background-size: cover;
      background-position: top center;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
